(function() {
    'use strict';
    angular
        .module('MW.Influencers.TextFilters', [
            'MW.Framework.TextServices',
            'MW.Framework.CoreCommon'
        ])
        .filter('icmTranslateDate', [
            'user',
            'moment',
            'MOMENT_MEDIUM_DATE',
            'MOMENT_FULL_DATE',
            function(user, moment, MOMENT_MEDIUM_DATE, MOMENT_FULL_DATE) {
                return function(date, format) {
                    if(date) {
                        var userTimezone = user.getTimezone(),
                            userLanguage = user.getLanguage() || 'en',
                            utcDate = moment.utc(date);

                        if(format) {
                            switch(format) {
                                case 'mediumDate':
                                    return utcDate.tz(userTimezone).locale(userLanguage).format(MOMENT_MEDIUM_DATE);
                                case 'fullDate':
                                    return utcDate.tz(userTimezone).locale(userLanguage).format(MOMENT_FULL_DATE);
                                default:
                                    return utcDate.tz(userTimezone).locale(userLanguage).format(format);
                            }
                        } else {
                            return utcDate.tz(userTimezone).locale(userLanguage).format();
                        }
                    } else {
                        return '';
                    }
                };
        }]);
})();